export default __webpack_public_path__ + "static/media/logo_GMX.c8eb0113.svg";